import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.map.js";
import VueAudio from 'vue-audio';
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import flexible from '../../../utils/flexible.js';
import { toSec } from '../../../utils/dateFormat';
import { Slider } from 'vant';
import 'vant/es/slider/style';
import guideBottom from '@/components/guideBottom.vue';
import { isWx } from '@/utils/utils';
var audio;
export default {
  name: 'audioDetail',
  data() {
    return {
      isPlaying: false,
      //播放按钮开关
      currentIndex: 0,
      imgList: [],
      nowTime: "00:00",
      totalTime: "",
      isFolded: false,
      antiqueDetail: {},
      location: '',
      formData: {},
      isFolded: true,
      audioPath: '',
      audio: {},
      maxValue: 1,
      //进度条长度（s）
      ctTime: 0,
      //当前进度条的值(s)
      recommendList: [],
      recommendIndex: [],
      touchNum: 0,
      hasPalyed: false,
      isLiked: false,
      //是否点击喜欢
      languageType: 0,
      hasChangeLanguage: false
    };
  },
  components: {
    'vue-audio': VueAudio,
    guideBottom
  },
  methods: {
    // 修改语音类型
    changeLanguage(type) {
      this.touchNum = 2;
      this.hasChangeLanguage = true;
      this.languageType = type;
      // this.stopAudio()
      // this.$refs.audioItem.currentTime = 0
      this.$nextTick(() => {
        this.setAudioPath(this.antiqueDetail[`audioPath_${this.languageType}`], 'refresh');
      });
      if (type == 3) {
        this.language = 'en';
      } else {
        this.language = '';
      }
      this.antiqueDetail.description = this.language ? this.antiqueDetail.en_introduction : this.antiqueDetail.introduction;
    },
    handleAudioTimeUpdate(e) {
      this.ctTime = e.target.currentTime;
      this.nowTime = this.formatSeconds(e.target.currentTime);
    },
    openUrl() {
      location.href = this.antiqueDetail.zhishituozhan;
    },
    // 开始拖动
    startMove: function () {
      this.stopAudio();
    },
    toDetail(item) {
      let query = this.$route.query;
      delete query.location;
      this.$router.push({
        path: `/audioDetail/${item.code}`,
        query
      });
    },
    touchstart() {
      if (this.touchNum > 2) return;
      this.touchNum += 1;
      if (this.touchNum > 1) return;
      this.playAudio();
    },
    changeTime() {
      this.nowTime = this.formatSeconds(this.ctTime);
      this.$refs.audioItem.currentTime = this.ctTime;
      this.playAudio();
    },
    toggleFold() {
      this.isFolded = !this.isFolded;
    },
    clickPlay(index, item) {
      if (!this.touchNum || this.touchNum == 1) return;
      this.isPlaying ? this.stopAudio(index) : this.playAudio(index);
    },
    stopAudio(index) {
      this.$refs.audioItem.pause();
      this.isPlaying = false;
    },
    playAudio() {
      this.isPlaying = true;
      if (!this.$refs.audioItem.paused) return;
      this.$refs.audioItem.play();
      if (!this.hasPalyed) {
        setTimeout(() => {
          this.ctTime = 0;
          this.hasPalyed = true;
        }, 500);
      }
    },
    getDetail(id) {
      this.audioPath = '';
      let searchStr = {
        filters: [[{
          alias: 'autoCode',
          compt: "editinput",
          express: '===',
          id: 28,
          range: null,
          val: this.id
        }]],
        model: 0
      };
      let formData = {
        page: 1,
        limit: 50,
        deptId: this.formData.fid,
        formId: this.formData.audio_formId,
        searchStr: encodeURI(JSON.stringify(searchStr))
      };
      this.$api.singleadvanceSearch(formData).then(res => {
        this.setDatas(res.dataList[0]);
        this.getRecommend();
      });
    },
    setDatas(data) {
      this.antiqueDetail = {
        antiqueName: !this.language ? this.getFormData(data, 'explainObj', 'val') : this.getFormData(data, 'en_explainObj', 'val'),
        description: !this.language ? this.getFormData(data, 'introduction', 'val') : this.getFormData(data, 'en_introduction', 'val'),
        audioPath: !this.language ? this.getFormData(data, 'audio', 'objectId') : this.getFormData(data, 'en_audio', 'objectId'),
        viewNum: this.getFormData(data, 'yuduliang', 'val'),
        //访问量
        likeNum: this.getFormData(data, 'dianzanliang', 'val'),
        id: data.id,
        formId: data.formId,
        zhishituozhan: this.getFormData(data, 'zhishituozhan', 'val'),
        fangyanleixing: this.getFormData(data, 'fangyanleixing', 'val'),
        en_explainObj: this.getFormData(data, 'en_explainObj', 'val'),
        explainObj: this.getFormData(data, 'explainObj', 'val'),
        en_introduction: this.getFormData(data, 'en_introduction', 'val'),
        introduction: this.getFormData(data, 'introduction', 'val'),
        // 三种音频文件
        audioPath_3: this.getFormData(data, 'en_audio', 'objectId'),
        audioPath_1: this.getFormData(data, 'audio', 'objectId'),
        audioPath_2: this.getFormData(data, 'fangyanyinpin', 'objectId'),
        41: this.getFormData(data, '41', 'val'),
        42: this.getFormData(data, '42', 'val')
        // duration: this.getFormData(data, 'time', 'val'),
      };
      this.editFormData(1); //访问量+1
      // 处理展览地点字段需根据后台实际信息实时更新
      this.location = this.language ? this.antiqueDetail['42'] === '' ? this.$route.query.location : this.antiqueDetail['42'] : this.antiqueDetail['41'] === '' ? this.$route.query.location : this.antiqueDetail['41'];
      console.log(this.antiqueDetail);
      document.title = this.antiqueDetail.antiqueName;
      this.imgList = this.getFormData(data, 'image', 'imgs');
      this.$nextTick(() => {
        new Swiper(this.$refs.swiperNav, {
          slidesPerView: 'auto',
          centeredSlides: true,
          touchMoveStopPropagation: true,
          runCallbacksOnInit: false,
          observer: true,
          //修改swiper自己或子元素时，自动初始化swiper
          observeParents: true,
          loop: true
        });
      });
      this.setAudioPath(this.antiqueDetail.audioPath);
      console.log(this.antiqueDetail.audioPath, 222);
      let share = {
        title: this.antiqueDetail.antiqueName,
        imgUrl: this.imgList[0]
      };
      console.log(share);
      isWx().then(type => {
        if (type !== 'mini-wx') this.wechatShare(share);
      });
      // this.wechatShare(share)
      // let maxValue = toSec(this.antiqueDetail.duration)
      // 设置duration时长为number
      // this.maxValue = maxValue
    },
    wechatShare(share) {
      return;
      let apiurl = '';
      if (location.protocol == 'http:') {
        apiurl = 'http://map.museum.chaoxing.com/beacon/config';
      } else if (location.protocol == 'https:') {
        apiurl = 'https://map-museum.chaoxing.com/beacon/config';
      }
      var promise = new Promise((resolve, reject) => {
        this.$ajax({
          url: apiurl + "?url=" + window.location.href,
          methods: 'get'
        }).then(res => {
          // console.log(res)
          resolve(res);
          // this.config = res
        }).catch(err => {
          console.log(err, 'wxerr');
          reject(err);
        });
      });
      promise.then(data => {
        wx.config({
          debug: false,
          // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.data.appId,
          // 必填，公众号的唯一标识
          timestamp: data.data.timestamp,
          // 必填，生成签名的时间戳
          nonceStr: data.data.nonceStr,
          // 必填，生成签名的随机串
          signature: data.data.signature,
          // 必填，签名，见附录1
          jsApiList: ['updateAppMessageShareData'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        var shareConfig = {
          share: {
            imgUrl: share.imgUrl,
            // 分享图标
            desc: '语音讲解',
            // 分享描述
            title: share.title,
            // 分享标题
            link: window.location.href,
            // 分享出去后的链接，这里可以将链接设置成另外一个页面，必须在同一域名下面
            success: function () {
              // 分享成功之后的回调
            },
            cancel: function () {
              // 用户取消分享后执行
            },
            fail: function (res) {
              alert(JSON.stringify(res));
            }
          }
        };
        // alert(JSON.stringify(shareConfig),'share')
        wx.ready(function () {
          wx.updateAppMessageShareData(shareConfig.share);
          wx.error(function (res) {
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            alert(JSON.stringify(res));
          });
          wx.checkJsApi({
            jsApiList: ['updateAppMessageShareData'],
            // 需要检测的JS接口列表，所有JS接口列表见附录2,
            success: function (res) {
              console.log(JSON.stringify(res));
            }
          });
        });
      });
    },
    formatSeconds(value) {
      let secondTime = parseInt(value); // 秒
      let minuteTime = 0; // 分
      let hourTime = 0; // 小时
      if (secondTime > 60) {
        minuteTime = parseInt(secondTime / 60);
        secondTime = parseInt(secondTime % 60);
        if (minuteTime > 60) {
          hourTime = parseInt(minuteTime / 60);
          minuteTime = parseInt(minuteTime % 60);
        }
      }
      let result = "" + this.addZero(parseInt(secondTime)) + "";
      if (minuteTime > 0) {
        result = "" + this.addZero(parseInt(minuteTime)) + ":" + result;
      } else {
        result = "" + this.addZero(parseInt(minuteTime)) + ":" + result;
      }
      if (hourTime > 0) {
        result = "" + parseInt(hourTime) + ":" + result;
      }
      return result;
    },
    // 左侧补零
    addZero(val) {
      if (val < 10) {
        return 0 + '' + val;
      } else {
        return val;
      }
    },
    setAudioPath(audioPath, type) {
      if (type == 'refresh') this.audioPath = '';
      if (!audioPath) return;
      this.$api.getUrlByObjectId(audioPath).then(res => {
        this.audioPath = res.http;
        if (type == 'refresh') {
          this.$nextTick(() => {
            this.playAudio();
          });
        }
        // this.audioPath = 'http://192.168.10.124:8080/test/test.mp3'
      });
    },
    getFormData(data, Tkey, key) {
      data = data.formIdValueData;
      if (!data[Tkey]) return '';
      let target = data[Tkey].groupValues[0];
      if (!target) return '';
      if (key == 'imgs') {
        let imgs = target.values.length && target.values[0] ? target.values[0] : [];
        return imgs.map(item => {
          return item.fileUrl;
        });
      }
      return target.values.length && target.values[0] ? target.values[0][0] ? target.values[0][0][key] : '' : '';
    },
    getRecommend() {
      this.recommendIndex = [];
      let formData = {
        page: 1,
        limit: 50,
        deptId: this.formData.fid,
        formId: this.formData.audio_formId
      };
      this.$api.singleadvanceSearch(formData).then(res => {
        let recommendList = this.setListDatas(res.dataList);
        recommendList.length > 1 ? this.rand(0, recommendList.length - 1) : '';
        recommendList.length > 2 ? this.rand(0, recommendList.length - 1) : '';
        this.recommendList = recommendList.filter((item, index) => {
          return this.recommendIndex.indexOf(index) > -1;
        });
        console.log(this.recommendList);
      });
    },
    replace() {
      this.getRecommend();
    },
    rand(m, n) {
      let data = Math.floor(Math.random() * (n - m)) + m;
      if (this.recommendIndex.indexOf(data) > -1) return this.rand(m, n);
      this.recommendIndex.push(data);
    },
    setListDatas(data) {
      return data.map(item => {
        return {
          exhibitionName: this.getFormData(item, 'exhibitionName', 'val'),
          antiqueName: this.language ? this.getFormData(item, 'en_explainObj', 'val') : this.getFormData(item, 'explainObj', 'val'),
          littleImage: this.getFormData(item, 'image', 'fileUrl'),
          code: this.getFormData(item, 'autoCode', 'val'),
          audioPath: this.getFormData(item, 'audio', 'objectId'),
          description: this.language ? this.getFormData(item, 'en_introduction', 'val') : this.getFormData(item, 'introduction', 'val'),
          en_explainObj: this.getFormData(item, 'en_explainObj', 'val'),
          explainObj: this.getFormData(item, 'explainObj', 'val'),
          en_introduction: this.getFormData(item, 'en_introduction', 'val'),
          introduction: this.getFormData(item, 'introduction', 'val')
        };
      });
    },
    getDuration(audioItem, index) {
      let audio = audioItem == 'audioItem' ? this.$refs[audioItem] : this.$refs[audioItem][0];
      if (audio.readyState > 0) {
        let minutes = parseInt(audio.duration / 60, 10);
        let seconds = parseInt(audio.duration % 60);
        minutes = minutes > 9 ? minutes : `0${minutes}`;
        seconds = seconds > 9 ? seconds : `0${seconds}`;
        audioItem == 'audioItem' ? this.totalTime = minutes + ":" + seconds : this.recommendList[index].duration = minutes + ":" + seconds;
        let maxValue = toSec(this.totalTime);
        this.maxValue = maxValue;
      }
    },
    // 编辑表单数据
    editFormData(type) {
      // type 1访问量 2 点赞量
      let putParams = [{
        "compt": "numberinput",
        "values": [{
          "val": this.antiqueDetail.viewNum ? parseInt(this.antiqueDetail.viewNum) + (type == 1 ? 1 : 0) : 0
        }],
        "alias": 'yuduliang'
      }, {
        "compt": "numberinput",
        "values": [{
          "val": this.antiqueDetail.viewNum ? parseInt(this.antiqueDetail.likeNum) + (type != 1 ? 1 : 0) : 0
        }],
        "alias": 'dianzanliang'
      }];
      putParams = encodeURI(JSON.stringify(putParams));
      this.$api.editForm(this.$route.query.fid, this.antiqueDetail.id, putParams, this.antiqueDetail.formId).then(res => {
        type == 2 ? this.isLiked = true : '';
        type == 2 ? this.antiqueDetail.likeNum = parseInt(this.antiqueDetail.likeNum) + 1 : '';
      });
    },
    setMyRecord() {
      let guideRecord = window.localStorage.getItem('guideRecord') ? JSON.parse(window.localStorage.getItem('guideRecord')) : [];
      guideRecord.push(this.id);
      window.localStorage.setItem('guideRecord', JSON.stringify(guideRecord));
    }
  },
  created() {
    flexible();
    let query = this.$route.query;
    this.location = query.location;
    this.id = this.$route.params.id;
    this.formData = {
      audio_formId: 171925,
      fid: query.fid
    };
    this.language = this.$route.query.language;
    this.getDetail(this.id);
    if (this.$route.query.fid != 152288) return;
    this.setMyRecord();
  },
  mounted() {},
  watch: {
    // 监听路由是否变化
    '$route'(to, from) {
      if (to.params.id != from.params.id) {
        this.id = to.params.id;
        this.location = to.query.location;
        this.totalTime = '';
        this.getDetail(this.id); // 重新调用加载数据方法
      }
    }
  },
  computed: {}
};